import { isMoneyValidCurrency, isPointsValidCurrency, isTokenValidCurrency } from "../currency";
import pure from "./higher-order/pure";
import React from "react";
import { TooltipInline } from "./tooltip";

function isWholeNumber(number) {
  var n = parseFloat(number).toFixed(2).split(".");
  return n[1] === "00";
}

const numberFormat = new Intl.NumberFormat([], { maximumFractionDigits: 0, minimumFractionDigits: 0 });
const numberAndDecimalFormat = new Intl.NumberFormat([], { maximumFractionDigits: 2, minimumFractionDigits: 2 });

export var FormattedPoints = pure(function FormattedPoints({ value }) {
  var format = isWholeNumber(value) ? numberFormat : numberAndDecimalFormat;
  return (
    <span>
      <PointsIcon />

      <span>
        {format.format(value)}
      </span>
    </span>
  );
});

export var FormattedTokenName = pure(function FormattedTokenName({ name }) {
  return (
    <span>
      <TokenIcon />

      <span>
        {formatTokenName(name)}
      </span>
    </span>
  );
});

export function formatTokenName(name) {
  return name.replace(/\s+token$/i, "") + " Token";
}

function PointsIcon() {
  return <i className="dw-points-solid" />;
}

function TokenIcon() {
  return <i className="dw-token" />;
}

export var FormattedTokenValue = pure(function FormattedTokenValue({ value }) {
  var format = isWholeNumber(value) ? numberFormat : numberAndDecimalFormat;
  return (
    <span>
      <TokenIcon />

      <span>
        {format.format(value)}
      </span>
    </span>
  );
});

const dollarsFormat = new Intl.NumberFormat([], { currency: "USD", maximumFractionDigits: 0, minimumFractionDigits: 0, style: "currency" });
const dollarsAndCentsFormat = new Intl.NumberFormat([], { currency: "USD", maximumFractionDigits: 2, minimumFractionDigits: 2, style: "currency" });

export var FormattedDollars = pure(function FormattedDollars({ showCents, value }) {
  var format = showCents || !isWholeNumber(value) ? dollarsAndCentsFormat : dollarsFormat;
  return format.format(value);
});

export var FormattedScore = pure(function FormattedScore({ value }) {
  return numberAndDecimalFormat.format(value);
});

export var FormattedPayout = pure(function FormattedPayout({ size, ticket, tokenTypes }) {
  var parts = [];
  if (ticket.get("money_payout") !== "0.00") {
    parts.push(<FormattedDollars key="dollars" value={ticket.get("money_payout")} />);
  }
  if (ticket.get("token_type_payout_id") !== null) {
    if (parts.length !== 0) {
      parts.push(<br key="tokenbreak" />);
    }
    var tokenType = tokenTypes.get(ticket.get("token_type_payout_id"));
    parts.push(<FormattedTokenName key="token" name={tokenType.get("name")} />);
  }
  if (ticket.get("points_payout") !== 0) {
    if (parts.length !== 0) {
      parts.push(<br key="pointsbreak" />);
    }
    parts.push(<FormattedPoints key="points" value={ticket.get("points_payout")} />);
  }

  if (size === "small") {
    return parts[0] || null;
  }
  return (
    <span>
      {parts}
    </span>
  );
});

export var FormattedBuyIn = pure(function FormattedBuyIn({ tokenTypes, tournament }) {
  var found = false;
  var parts = [];
  if (isMoneyValidCurrency(tournament)) {
    parts.push(<FormattedDollars key="dollars" value={tournament.get("money_buy_in_amount")} />);
    found = true;
  }
  if (isTokenValidCurrency(tournament)) {
    var tokenType = tokenTypes.get(tournament.get("token_type_id"));
    if (found) {
      parts.push(
        <TooltipInline key="token" text={formatTokenName(tokenType.get("name"))}>
          {" "}

          <TokenIcon />
        </TooltipInline>
      );
    } else {
      parts.push(<FormattedTokenValue key="token" value={tokenType.get("value")} />);
    }
    found = true;
  }
  if (isPointsValidCurrency(tournament)) {
    if (found) {
      parts.push(
        <span key="points">
          {" "}

          <PointsIcon />
        </span>
      );
    } else {
      parts.push(<FormattedPoints key="points" value={tournament.get("points_buy_in_amount")} />);
    }
  }
  return (
    <span>
      {parts}
    </span>
  );
});

export var AutoFormattedCurrency = pure(function AutoFormattedCurrency({ currency, value }) {
  if (currency === "usd") {
    return <FormattedDollars key="dollars" value={value} />;
  }
  if (currency === "token") {
    return <FormattedTokenValue key="token" value={value} />;
  }
  if (currency === "points") {
    return <FormattedPoints key="points" value={value} />;
  }
  return null;
});

export default pure(function FormattedCurrency({ dollarsValue, pointsValue, tokenName, tokenValue }) {
  var parts = [];

  if (dollarsValue !== undefined && dollarsValue !== null) {
    parts.push(<FormattedDollars key="dollars" value={dollarsValue} />);
  }

  if (tokenValue !== undefined && tokenValue !== null) {
    if (parts.length !== 0) {
      parts.push(
        <span className="tournament-table_payout-note" key="token-plus">
          {" "}
          +

          {" "}
        </span>
      );
    }
    parts.push(<FormattedToken key="token" name={tokenName} value={tokenValue} />);
  }

  if (pointsValue !== undefined && pointsValue !== null) {
    if (parts.length !== 0) {
      parts.push(
        <span className="tournament-table_payout-note" key="points-plus">
          {" "}
          +

          {" "}
        </span>
      );
    }
    parts.push(<FormattedPoints key="points" value={pointsValue} />);
  }

  return (
    <span>
      {parts}
    </span>
  );
});

var FormattedToken = pure(function FormattedToken({ name, value }) {
  var format = isWholeNumber(value) ? numberFormat : numberAndDecimalFormat;
  return (
    <span>
      <TokenIcon />

      <span>
        {format.format(value)}
      </span>

      <span className="tournament-table_payout-note">
        {" "}
        (

        {name}
        )
      </span>
    </span>
  );
});
